import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableUsersComponent } from './table-users.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ActionsTableModule } from '../../commons/actions-table/actions-table.module';
import { ComponentsModule } from '../component.module';
import { loadingSpinnerModule } from '../../commons/loading-spinner/loading-spinner.module';
import { LayoutTableModule } from 'projects/access-control/src/app/UI/commons/layout-table/layout-table.module';
import { CommonsModule } from 'projects/access-control/src/app/UI/commons/commons.module';
@NgModule({
	declarations: [TableUsersComponent],
	exports: [TableUsersComponent],
	imports: [
		CommonModule,
		NgxDatatableModule,
		LayoutTableModule,
		CommonsModule,
		ActionsTableModule,
		ComponentsModule,
		loadingSpinnerModule,
	],
})
export class TableUserModule {}
